import * as React from "react";
import { useContext, useState } from "react";
import { Button, Checkbox, Divider, Dropdown, Grid, Input } from 'semantic-ui-react';
import Notifications from 'react-notify-toast';
import {
    FreightStatus,
    StopActionStatus,
    StopLocationStatus,
    TelematicState,
    TransportOrderChange,
    TransportOrderStatus,
    TransportOrderTestEventRequest
} from "../../../../../generated";
import { ConfigContext } from "../../../context/ConfigContext";
import { backend } from "../../../../../xconvert-backend";
import { authentication } from "../../../../../authentication";
import { IfBox } from "../../../../style/if";
import {orderToEvent, orderToPositionEvent, orderToQueuedEtaEvent} from "../../converter/ExportSim/Converter";
import {DropDownEnum} from "../../converter/ExportSim/input/ExportSimTransportOrderEditor";
import 'brace/mode/groovy'
import 'brace/ext/searchbox'

export enum EventEnum {
    ASSIGN_COMPANY_EVENT = "AssignCompanyEvent",
    UPDATE_EVENT = "UpdateEvent",
    STORNO_EVENT = "StornoEvent",
    STATUS_UPDATE_EVENT = "StatusUpdateEvent",
    POSITION_EVENT = "PositionEvent",
    ETA_EVENT = "EtaEvent"
}

export function QueuedEventCreator(props) {
    const context = useContext(ConfigContext);

    const [isConverting, setIsConverting] = useState(false);
    const [exportSimToId, setExportSimToId] = useState("");
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [type, setType] = useState(null);
    const [telematicState, setTelematicState] = useState(false);
    const [status, setStatus] = useState(null);
    const [telematicStateCode, setTelematicStateCode] = useState(null);

    function getStatus() {
        return telematicState ? telematicStateCode : status;
    }

    function enumToArray() {
        return Object.values(EventEnum).map(value => ({
            key: value, value: value, text: value
        }));
    }

    function eventEnumToArray() {
        return Object.values(EventEnum).map(value => ({
            key: value, value: value, text: value
        }));
    }

    function statusTypeEnumToArray() {
        return Object.values(DropDownEnum).map(value => ({
            key: value, value: value, text: value
        }));
    }

    function statusEnumToArray() {
        let enumValues = [];
        switch (type) {
            case TransportOrderChange.TypeEnum.STATUSUPDATETRANSPORTORDER:
                if (telematicState) {
                    Object.values(TelematicState.StatusCodeEnum).forEach(value => {
                        enumValues.push({ key: value, value: value, text: value });
                    });
                } else {
                    Object.values(TransportOrderStatus.StatusCodeEnum).forEach(value => {
                        enumValues.push({ key: value, value: value, text: value });
                    });
                }
                break;
            case TransportOrderChange.TypeEnum.STATUSUPDATESTOPLOCATION:
                Object.values(StopLocationStatus.StatusCodeEnum).forEach(value => {
                    enumValues.push({ key: value, value: value, text: value });
                });
                break;
            case TransportOrderChange.TypeEnum.STATUSUPDATESTOPACTION:
                Object.values(StopActionStatus.StatusCodeEnum).forEach(value => {
                    enumValues.push({ key: value, value: value, text: value });
                });
                break;
            case TransportOrderChange.TypeEnum.STATUSUPDATEFREIGHT:
                Object.values(FreightStatus.StatusCodeEnum).forEach(value => {
                    enumValues.push({ key: value, value: value, text: value });
                });
                break;
        }
        return enumValues;
    }

    async function createEvent() {
        setIsConverting(true);
        const authHeader = backend.withTokenAuthHeader(authentication.token);
        const transportOrder = await backend.transportOrderApi.fetchTransportOrderById(exportSimToId, authHeader);

        let eventType: TransportOrderTestEventRequest.EventTypeEnum = null;
        switch (selectedEvent) {
            case EventEnum.ASSIGN_COMPANY_EVENT:
                eventType = TransportOrderTestEventRequest.EventTypeEnum.ASSIGNCOMPANY;
                break;
            case EventEnum.UPDATE_EVENT:
                eventType = TransportOrderTestEventRequest.EventTypeEnum.UPDATE;
                break;
            case EventEnum.STORNO_EVENT:
                eventType = TransportOrderTestEventRequest.EventTypeEnum.STORNO;
                break;
            case EventEnum.STATUS_UPDATE_EVENT:
                eventType = type
                break;
            case EventEnum.POSITION_EVENT:
                orderToPositionEvent(
                    context,
                    transportOrder,
                    exportSimToId,
                ).then((eventAndConfig) => {
                    props.dispatch(eventAndConfig.event);
                    setIsConverting(false);
                }
                )
                break;
            case EventEnum.ETA_EVENT:
                props.dispatch(orderToQueuedEtaEvent(transportOrder))
                setIsConverting(false);
                break;

        }
        if(eventType != null) {
            orderToEvent(
                context,
                transportOrder,
                exportSimToId,
                eventType,
                status,
                telematicStateCode,
            ).then((eventAndConfig) => {
                props.dispatch(eventAndConfig.event);
                setIsConverting(false);
            });
        }
    }

    function drawButtons() {
        return (
            <Grid padded="horizontally" stackable columns='equal' centered>
                <Grid.Column>
                    <Dropdown
                        selectOnBlur={false}
                        placeholder='Select Type'
                        fluid
                        search
                        selection
                        options={enumToArray()}
                        clearable
                        onChange={(event, { value }) => setSelectedEvent(value)}
                    />
                </Grid.Column>
                <Grid.Column>
                    <Button
                        disabled={selectedEvent == null}
                        onClick={createEvent}
                        loading={isConverting}
                    >
                        create Event
                    </Button>
                </Grid.Column>
            </Grid>
        );
    }

    function _setType(event, {value}) {
        console.log(value);

        switch (event.target.textContent) {
            case DropDownEnum.TRANSPORT_ORDER:
                setType(TransportOrderChange.TypeEnum.STATUSUPDATETRANSPORTORDER)
                break;

            case DropDownEnum.STOP_LOCATION:
                setType(TransportOrderChange.TypeEnum.STATUSUPDATESTOPLOCATION);
                break;

            case DropDownEnum.STOP_ACTION:
                setType(TransportOrderChange.TypeEnum.STATUSUPDATESTOPACTION);
                break;

            case DropDownEnum.FREIGHT:
                setType(TransportOrderChange.TypeEnum.STATUSUPDATEFREIGHT);
                break;
        }
    }

    function drawTypeSelection() {
        const options = eventEnumToArray();
        return (
            <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                <div style={{ paddingLeft: 20 }}>
                    <Dropdown
                        selectOnBlur={false}
                        placeholder='Select Type'
                        search
                        selection
                        options={options}
                        clearable
                        defaultValue={EventEnum.ASSIGN_COMPANY_EVENT}
                        onChange={(event, { value }) => setSelectedEvent(value)}
                    />
                </div>
                <IfBox shouldShow={selectedEvent == EventEnum.STATUS_UPDATE_EVENT}>
                    <div style={{ paddingLeft: 20 }}>
                        <p>Update
                            <Dropdown
                                selectOnBlur={false}
                                placeholder='Select'
                                search
                                style={{ marginLeft: 10, marginRight: 10 }}
                                selection
                                options={statusTypeEnumToArray()}
                                clearable
                                onChange={_setType}
                            />
                            Status</p>
                    </div>
                    <div style={{ paddingLeft: 20, display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                        <p>To
                            <Dropdown
                                selectOnBlur={false}
                                disabled={type == null}
                                placeholder='Select Status'
                                search
                                style={{ marginLeft: 10, marginRight: 10 }}
                                selection
                                options={statusEnumToArray()}
                                clearable
                                onChange={(_, { value }) => setStatus(value)}
                                value={getStatus()}
                            />
                        </p>
                        <IfBox shouldShow={type == TransportOrderChange.TypeEnum.STATUSUPDATETRANSPORTORDER}>
                            <div style={{ paddingLeft: 25 }}>
                                Status -
                                <Checkbox
                                    disabled={type != TransportOrderChange.TypeEnum.STATUSUPDATETRANSPORTORDER}
                                    type='checkbox'
                                    toggle
                                    onChange={() => {
                                        setTelematicState(!telematicState);
                                        setStatus(null);
                                        setTelematicStateCode(null);
                                    }}
                                />
                                - TelematicState
                            </div>
                        </IfBox>
                    </div>
                </IfBox>
            </div>
        );
    }

    return (
        <Grid padded="horizontally" stackable columns='equal' centered>
            <Grid.Column width='5'>
                <Input
                    style={{ width: 220 }}
                    placeholder='TransportOrderId'
                    value={exportSimToId}
                    onChange={evt => setExportSimToId(evt.target.value)}
                />
                <Divider hidden />
            </Grid.Column>
            <Grid.Column>
                {drawButtons()}
                {drawTypeSelection()}
            </Grid.Column>
            <Notifications />
        </Grid>
    );
}